import { InsightResult, MindsetResult } from "@/types";


export interface Column {
  name: string;
  label: string;
  formatter?: (value: any) => string;
}

export const prepareData = (
  data: InsightResult[] | MindsetResult[],
  columns: Column[],
  includeHeaders: boolean = true,
  delimiter: string = ","
) => {

  const rows: string[] = [];

  if (includeHeaders) {
    const headers = columns.map((col) => escapeCSVField(col.label));
    rows.push(headers.join(delimiter));
  }

  data.forEach((row) => {
    const rowData = processRow(row, columns, delimiter);
    rows.push(rowData);
  });

  return rows.join("\n");
};

export const processRow = (
  row: InsightResult | MindsetResult,
  columns: Column[],
  delimiter: string
): string => {
  return columns
    .map((col) => {
      const value = row[col.name as keyof (InsightResult | MindsetResult)];
      const formattedValue = col.formatter ? col.formatter(value) : value;
      return escapeCSVField(formattedValue);
    })
    .join(delimiter);
};


export const downloadFile = (csv: string, filename: string): void => {
  if (!csv || !filename) return;

  const sanitizedFilename = filename.replace(/[<>:"/\\|?*]/g, "_");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = sanitizedFilename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const escapeCSVField = (value: any): string => {
  if (value === null || value === undefined) {
    return "";
  }

  const stringValue = String(value);
  const escapedValue = stringValue.replace(/"/g, '""');

  return `"${escapedValue}"`;
};
